function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfo = function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M14.0025 16.005H13.335C12.9809 16.005 12.6414 15.8643 12.391 15.614C12.1406 15.3636 12 15.024 12 14.67V11.3325C12 11.1554 11.9297 10.9857 11.8045 10.8605C11.6793 10.7353 11.5095 10.665 11.3325 10.665H10.665M12 7.99999H12.01M22.0125 12C22.0125 17.5297 17.5297 22.0125 12 22.0125C6.47024 22.0125 1.98749 17.5297 1.98749 12C1.98749 6.47024 6.47024 1.98749 12 1.98749C17.5297 1.98749 22.0125 6.47024 22.0125 12Z",
    fill: "none",
    stroke: props.fill,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};
export default SvgInfo;